import '../styles/map.css'
import React from 'react';

import { mockMapConfig } from '../map-config';

import 'ol/ol.css';

import AddressSearchInputComponent from './address-search-input';

import DebugTools from './mapdebug';

const queryParams = new URLSearchParams(window.location.hash.split("?")[1]);

const debugMap = queryParams.has('debugMap');
const debugThemes = queryParams.has('debugThemes');
const nocache = queryParams.has('nocache')

window.themesDebug = debugThemes;


class MapComponent extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      config: mockMapConfig,
      categories: undefined,
      mapObj: undefined,
      timelineEntries: [],
      lastZoom: -1,
      arialOpacityAnimation: null
    }

  } 

  sizeChanged = () => {
    if (this.state.mapObj) { 
      this.state.mapObj.updateSize();
    }
  }

  componentDidMount = () => {
    setTimeout(() => { this.processConfig(this.state.config) }, 1000);
    new ResizeObserver(this.sizeChanged).observe(document.getElementById('map'));
  }


  createMapIfNotExists = () => {
    let map = this.state.mapObj;

    if(this.props.getMap)
      map = this.props.getMap('map');
    
    if(map) {
      this.setState({mapObj: map});
    }

    return map;
  }

  processConfig = (config) => {
    let mapObj = this.createMapIfNotExists();

    if (mapObj.themes.categories && mapObj.themes.categories.length > 0)
      return;


    try {
      if (nocache) {
        config.layers.forEach(layer => {
          if (layer.mvt) {
            layer.mvt.endpoints.forEach(endpoint => {
              endpoint.url = endpoint.url + "?nocache=true&rnd=" + Math.random();
            });
          }
        });
      }

      let resultConfig = mapObj.themes.initCategories(config, true);

      if(this.props.useCategories)
        this.props.useCategories(resultConfig.categories);

      return { categories: resultConfig.categories, config: resultConfig.config, valid: true };
    }
    catch (ex) {
      return { categories: [], config, valid: false, error: ex };
    }
  }

  render() {
    let debugTools = null;
    
    if (debugMap) {
      debugTools = (<DebugTools mapObj={this.state.mapObj} zoom={this.state.lastZoom} lon={this.state.lastLon} lat={this.state.lastLat} />);
    }

    return (
      <div className="MapComponentContainer">
        <div className="MapContainer no-print">
          <div id="map" className="map">
          </div>
        </div>
        <div className="SearchOverlay no-print">
          <AddressSearchInputComponent startAddress={this.props.startAddress} />
        </div>
        {debugTools}
        <div id="print-map-container" className='print-map-container'>
          <img id="print-map" className='print-map' alt='map'/>
        </div>
      </div>
    )
  }
}


export default MapComponent;